export default "__VITE_ASSET__BhhyLkc7__"